export default "__VITE_ASSET__b3aa4c74__"